exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.contact[data-v-00d39fe4] {\n    display: block;\n}\ntr td[data-v-00d39fe4] {  font-size: 13px; padding: 20px 10px; padding-left: 0; border-bottom: solid 1px rgba(150,150,150,0.1);\n}\ntr[data-v-00d39fe4]:hover { background: #fbf7fd;\n}\ntr.header td[data-v-00d39fe4] { font-weight: 700;\n}\ntr.header[data-v-00d39fe4]:hover { background: #fff;\n}\ntd p.address[data-v-00d39fe4] { max-width: 172px;\n}\n", ""]);

// exports
